export default __webpack_public_path__ + "static/media/icon-Training-Courses.49ef7e62.svg";